import classNames from 'classnames'
import { bool, node, shape, string } from 'prop-types'

import { getTrackingDataUrlParams } from 'shared/utils/algolia/trackingDataHelper'
import getProductUrl from 'shared/utils/getProductUrl'
import Input from 'views/components/atoms/Input'

const ProductVariantWrapper = ({
  radioButton,
  children,
  canonicalURL,
  id,
  groupName,
  checked,
  isOutOfTrade,
  isOutOfStock,
  isLast,
  trackingData,
  isNotLink,
  path,
}) => {
  const containerClassName = classNames(
    'm-ProductVariant m-ProductVariant--main',
    {
      'm-ProductVariant--disabled': isOutOfTrade,
      'm-ProductVariant__label--out-of-stock': isOutOfStock,
    }
  )
  const labelClassName = classNames('m-ProductVariant__label l-flex', {
    'm-ProductVariant__label--checked': checked,
    'm-ProductVariant__label--last': isLast,
  })
  const innerWrapperProps = {}

  if (!isNotLink) {
    innerWrapperProps.className =
      'a-link a-link--neutral m-ProductVariant__link'

    const productUrl = canonicalURL ? getProductUrl(canonicalURL) : path

    innerWrapperProps.href = `${productUrl}${getTrackingDataUrlParams(
      trackingData
    )}`
    innerWrapperProps['data-product-variant-id'] = id

    if (isOutOfStock) {
      innerWrapperProps['data-clientside-hook'] =
        'productVariant__link m-ProductVariant__link--out-of-stock'
    } else {
      innerWrapperProps['data-clientside-hook'] = 'productVariant__link'
    }
  }

  if (isNotLink && isOutOfStock) {
    innerWrapperProps['data-clientside-hook'] =
      'm-ProductVariant__link--out-of-stock'
    innerWrapperProps['data-product-variant-id'] = id
  }

  const Wrapper = wrapperProps => {
    if (radioButton) {
      return (
        <div className={containerClassName}>
          <div className="m-ProductVariant__link">
            <Input
              type="radio"
              value={id}
              id={id}
              name={groupName}
              className="m-ProductVariant__input u-hidden"
              defaultChecked={checked}
            />
            <label htmlFor={id} className={labelClassName}>
              {wrapperProps.children}
            </label>
          </div>
        </div>
      )
    }

    const InnerWrapper = isOutOfTrade || checked ? 'div' : 'a'
    return (
      <div className={containerClassName}>
        <InnerWrapper {...innerWrapperProps}>
          <div className={labelClassName}>{children}</div>
        </InnerWrapper>
      </div>
    )
  }

  return <Wrapper>{children}</Wrapper>
}

ProductVariantWrapper.propTypes = {
  radioButton: bool.isRequired,
  children: node.isRequired,
  canonicalURL: string.isRequired,
  path: string,
  id: string.isRequired,
  groupName: string.isRequired,
  checked: bool.isRequired,
  isOutOfTrade: bool.isRequired,
  isOutOfStock: bool.isRequired,
  isLast: bool.isRequired,
  isNotLink: bool.isRequired,
  trackingData: shape({}),
}

ProductVariantWrapper.defaultProps = {
  trackingData: null,
}

export default ProductVariantWrapper
